"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instance = void 0;
var api_sdk_1 = require("@clearabee/api-sdk");
exports.instance = api_sdk_1.createInstance({
    withCredentials: false,
});
